import { arrayUnion, doc, setDoc, updateDoc } from 'firebase/firestore'
import React, { useContext } from 'react'
import { db } from '../../config'
import { AuthContext } from '../../context/AuthContext'

const AddGroup = () => {
  const { curUser } = useContext(AuthContext)
  const handleGroup = async () => {
    try {
      const groupName = prompt('Enter the group name: ', 'New group')
      if (groupName != null) {
        const d = new Date()
        const curTime = d.getTime()
        const combinedId = groupName + '-' + curTime
        await setDoc(doc(db, 'groups', combinedId), {
          combinedId: combinedId,
          groupName: groupName,
          member: arrayUnion(curUser.uid),
          message: [],
        })
        await updateDoc(doc(db, 'usergroups', curUser.uid), {
          [combinedId + '.groupInfo']: {
            groupName: groupName,
          },
        })
      }
    } catch (err) {
      alert(err.code)
      console.log(err.message)
    }
  }

  return (
    <button className="addGroup" onClick={handleGroup}>
      + CREATE
    </button>
  )
}

export default AddGroup
